import MobileDetect from 'mobile-detect';
import { getCodeUrl, redirect, URLs } from './common/utils/url';

const baseUrls = [URLs.controller, URLs.hoster];

function main() {
  console.log(window.location.pathname);

  if (baseUrls.some((url) => window.location.pathname.startsWith(url))) {
    return;
  }

  if (window.location.pathname.length > 1) {
    console.log('redirecting to code');
    return redirect(getCodeUrl(window.location.pathname.slice(1)));
  }

  const md = new MobileDetect(window.navigator.userAgent);

  console.log(window.location);

  if (md.mobile()) {
    return redirect(URLs.controller);
  } else {
    return redirect(URLs.hoster);
  }
}

main();
